import { GAConfig, GACountryCode } from '@domgen/dgx-fe-ga';
import { AppConfig } from '../../models/config/app-config.type';

export const gaConfigFactory = (config: AppConfig): GAConfig => ({
  clientBrandCode: config.clientBrandCode,
  countryCode: GACountryCode.UnitedStates,
  debug: false,
  domainId: config.domainId,
  httpErrorMapping: {},
});
